import { Button, TextField, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

type ExternalProviderProps = {
  defaultExternalProvider: string;
  onNextButtonClick: () => void;
};

function ExternalProvider({
  defaultExternalProvider,
  onNextButtonClick,
}: ExternalProviderProps) {
  const { t } = useTranslation(["common", "externalCampaign"]);

  return (
    <div>
      <Typography className="mb-lg">
        {t("externalCampaign:externalProvider.description")}
      </Typography>
      <TextField
        name="externalProvider"
        label={t("externalCampaign:externalProvider.label")}
        defaultValue={defaultExternalProvider}
        placeholder={t("externalCampaign:externalProvider.placeholder")}
        fullWidth
      />

      <div className="mt-lg text-center">
        <Button onClick={onNextButtonClick}>{t("common:next")}</Button>
      </div>
    </div>
  );
}

export default ExternalProvider;
